import React, { useContext, useEffect, useMemo, useState } from 'react'
// import OffToggle from '../Components/Images/OffToggle.png';
// import OnToggle from '../Components/Images/OnToggle.png';
import { Context } from '../Context/Context'
import Select from 'react-select';
// import { AiTwotoneQuestionCircle } from "react-icons/ai";
// import Bank from '../Components/Images/bank.svg';
import close from '../Components/Images/x-close.png';
// import { FaRegImage } from 'react-icons/fa';
// import SendModal from './SendModal';
// import user from '../Components/Images/user.png';

const SendBarFromBeneficiary = ({ Benficiary, setSendErrorBar, setOpenSendBar }) => {

    const {
        handleSendBarFromBeneficiary,
        sendBarFromBeneficiary,
        fetchAccountsAndWalletData,
        method,
        setMethod,
        setBeneficiaryAcct,
        beneficiaryAcct,
        formDatas,
        setFormDatas,
        cryptoformData,
        setCryptoFormData,
        beneficiaryAcctInCrypto,
        setBeneficiaryAcctInCrypto
    } = useContext(Context)
    // const [toggle, setToggle] = useState(false)
    const [selectedBenAcct, setSelectedBenAcct] = useState([])
    const [beneficiaries, setBeneficiaries] = useState([])
    const [rates, setRates] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false);
    // const [file, setFile] = useState(null)

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (Benficiary === 'crypto') {
            setMethod('crypto')
        } else {
            setMethod('bank')
        }
    }, [Benficiary, setMethod]);

    // const currencyOptions = accounts.map((account) => ({
    //     value: `bank-${account.currency}`,
    //     label: (
    //         <div className="flex items-center gap-2">
    //             <img
    //                 src={currencyLogos[account.currency]}
    //                 alt={account.currency}
    //                 className="w-5"
    //             />
    //             <span>{account.currency}</span>
    //             <span>{account.account_number}</span>
    //         </div>
    //     ),
    // }));

    // const currencyOptionsInCrypto = accounts.map((account) => ({
    //     value: `crypto-${account.currency}`,
    //     label: (
    //         <div className="flex items-center gap-2">
    //             <img
    //                 src={currencyLogos[account.currency]}
    //                 alt={account.currency}
    //                 className="w-5"
    //             />
    //             <span>{account.currency}</span>
    //             <span>{account.account_number}</span>
    //         </div>
    //     ),
    // }));

    useEffect(() => {
        const fetchRates = async () => {
            if (!selectedBenAcct?.value || !selectedBenAcct?.currency) return;

            const token = localStorage.getItem('token');

            try {
                const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/payments/rate?country_code=${selectedBenAcct.value}&currency_code=${selectedBenAcct.currency}`, {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Token ${token}`,
                        'Content-Type': 'application/json'
                    },
                });

                const data = await res.json();
                if (res.ok) {
                    setRates(data.rate);
                    setSelectedBenAcct((prev) => ({
                        ...prev,
                        rate: data.rate
                    }));
                } else {
                    console.error('Rate fetch error:', data.message);
                }
            } catch (err) {
                console.error('Rate fetch failed:', err);
            }
        };

        fetchRates();
    }, [selectedBenAcct?.value, selectedBenAcct?.currency]);


    const BankBeneficairyOptions = beneficiaries
        .filter((ben) => ben.account_type === 'fiat')
        .map((ben) => ({
            value: `bank-${ben.id}`,
            full_name: ben.full_name,
            currency: ben.currency,
            label: (
                <div className='flex items-center gap-1'>
                    {ben.country_code ? (
                        <img
                            src={`https://flagcdn.com/w40/${ben.country_code.toLowerCase()}.png`}
                            alt={ben.currency}
                            className="w-[20px] h-4 rounded-sm"
                        />
                    ) : (
                        <div />
                    )}
                    {ben.full_name}
                </div>
            )
        }));

    const BeneficairyOptionsInCrypto = beneficiaries
        .filter((ben) => ben.account_type !== 'fiat')
        .map((ben) => ({
            value: `crypto-${ben.id}`,
            label: (
                <div className='flex items-center gap-1'>
                    {ben.country_code ? (
                        <img
                            src={`https://flagcdn.com/w40/${ben.country_code.toLowerCase()}.png`}
                            alt={ben.currency}
                            className="w-[20px] h-4 rounded-sm"
                        />
                    ) : (
                        <div />
                    )}
                    {ben.full_name}
                </div>
            )
        }));

    // const countryOptionsWithRates = [
    //     {
    //         label: "Select Country",
    //         value: "",
    //         isDisabled: true,
    //     },
    //     {
    //         label: "USA",
    //         value: "US",
    //         currency: "USD",
    //         symbol: "$",
    //         rate: rates,
    //     },
    //     {
    //         label: "South Africa",
    //         value: "ZA",
    //         currency: "ZAR",
    //         symbol: "R",
    //         rate: rates,
    //     },
    //     {
    //         label: "Nigeria",
    //         value: "NG",
    //         currency: "NGN",
    //         symbol: "₦",
    //         rate: rates,
    //     },
    //     {
    //         label: "United Kingdom",
    //         value: "GB",
    //         currency: "GBP",
    //         symbol: "£",
    //         rate: rates,
    //     },
    //     {
    //         label: "Canada",
    //         value: "CA",
    //         currency: "CAD",
    //         symbol: "C$",
    //         rate: rates,
    //     },
    //     {
    //         label: "Ghana",
    //         value: "GH",
    //         currency: "GHS",
    //         symbol: "₵",
    //         rate: rates,
    //     },
    //     {
    //         label: "Kenya",
    //         value: "KE",
    //         currency: "KES",
    //         symbol: "KSh",
    //         rate: rates,
    //     },
    //     {
    //         label: "China",
    //         value: "CN",
    //         currency: "CNY",
    //         symbol: "¥",
    //         rate: rates,
    //     },
    //     {
    //         label: "India",
    //         value: "IN",
    //         currency: "INR",
    //         symbol: "₹",
    //         rate: rates,
    //     },
    //     {
    //         label: "Philippines",
    //         value: "PH",
    //         currency: "PHP",
    //         symbol: "₱",
    //         rate: rates,
    //     },
    //     {
    //         label: "Pakistan",
    //         value: "PK",
    //         icon: "https://flagcdn.com/w40/pk.png",
    //         currency: "PKR",
    //         symbol: "₨",
    //         rate: rates,
    //     },
    //     {
    //         label: "Sweden",
    //         value: "SE",
    //         icon: "https://flagcdn.com/w40/se.png",
    //         currency: "SEK",
    //         symbol: "kr",
    //         rate: rates,
    //     },
    //     {
    //         label: "Switzerland",
    //         value: "CH",
    //         icon: "https://flagcdn.com/w40/ch.png",
    //         currency: "CHF",
    //         symbol: "Fr",
    //         rate: rates,
    //     },
    // ];

    const countryOptionsWithRates = useMemo(() => [
        { label: "Select Country", value: "", isDisabled: true },
        { label: "Uganda", value: "UG", currency: "UGX", symbol: "USh", icon: "https://flagcdn.com/w40/ug.png", rate: rates },
        { label: "Tanzania", value: "TZ", currency: "TZS", symbol: "TSh", icon: "https://flagcdn.com/w40/tz.png", rate: rates },
        { label: "Nigeria", value: "NG", currency: "NGN", symbol: "₦", icon: "https://flagcdn.com/w40/ng.png", rate: rates },
        { label: "Malawi", value: "MW", currency: "MWK", symbol: "MK", icon: "https://flagcdn.com/w40/mw.png", rate: rates },
        { label: "Kenya", value: "KE", currency: "KES", symbol: "KSh", icon: "https://flagcdn.com/w40/ke.png", rate: rates },
        { label: "Brazil", value: "BR", currency: "BRL", symbol: "R$", icon: "https://flagcdn.com/w40/br.png", rate: rates },
    ], [rates]);


    const fetchBeneficiary = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/beneficiary`, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Failed to fetch beneficiary');
            }

            return data;
        } catch (error) {
            console.error('Error fetching beneficiary:', error.message);
            return null;
        }
    };

    useEffect(() => {
        if (!sendBarFromBeneficiary) return
        const getBeneficiaries = async () => {
            const data = await fetchBeneficiary();
            if (data) {
                setBeneficiaries(data);
            }
        };

        getBeneficiaries();
    }, [sendBarFromBeneficiary]);

    const sendMoney = async (e) => {
        e.preventDefault()

        const error = {}

        if (!beneficiaryAcct || !beneficiaryAcct.value) {
            error.beneficiaryAcct = 'Please select an account!'
        }

        if (!formDatas.amount) {
            error.amount = 'Please enter amount to send!'
        }

        if (!formDatas.note) {
            error.note = 'Please leave a remark for this transfer!'
        }

        if (Object.keys(error).length > 0) {
            setErrors(error)
            return
        }

        setErrors({});

        setIsSubmitting(true);

        try {
            const token = localStorage.getItem('token')

            const payload = {
                beneficiary: formDatas.beneficiary,
                amount: formDatas.amount.toString(),
                note: formDatas.note,
                currency: formDatas.currency,
            };

            // const formBody = new FormData();
            // formBody.append('beneficiary', formDatas.beneficiary);
            // formBody.append('amount', formDatas.amount);
            // if (file instanceof File) {
            //     formBody.append('file', formDatas.file);
            // }


            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/payments/local`, {
                method: 'POST',
                headers: {
                    Authorization: `Token ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })

            const data = await response.json();

            if (!response.ok) {
                const errorMessage =
                    data?.data?.message || data?.message || 'Failed to send payment'
                setSendErrorBar({ state: true, message: errorMessage })
                handleSendBarFromBeneficiary()
                throw new Error(data.message || 'failed');
            } else {
                console.log('moneySent:', data);
                window.scrollTo(0, 0)
                handleSendBarFromBeneficiary()
                setOpenSendBar(true)
                fetchAccountsAndWalletData()
            }

        } catch (error) {
            console.error('Error while sending money:', error.message);
            setSendErrorBar({ state: true, message: 'Failed to send payment. Try again later' })
        } finally {
            setIsSubmitting(false);
        }
    }

    const sendMoneyInCrypto = async (e) => {
        e.preventDefault()

        const error = {}

        if (!beneficiaryAcctInCrypto || !beneficiaryAcctInCrypto.value) {
            error.beneficiaryAcctInCrypto = 'Please select an account!'
        }

        if (!cryptoformData.amount) {
            error.amount = 'Please enter amount to send!'
        }

        if (Object.keys(error).length > 0) {
            setErrors(error)
            return
        }

        setErrors({});

        setIsSubmitting(true);

        try {
            const token = localStorage.getItem('token')

            const payload = {
                beneficiary: cryptoformData.beneficiary,
                amount: cryptoformData.amount.toString()
            };
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/payments/crypto`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })

            const data = await response.json();

            if (!response.ok) {
                const errorMessage =
                    data?.data?.message || data?.message || 'Failed to send payment'
                handleSendBarFromBeneficiary()
                setSendErrorBar({ state: true, message: errorMessage })
                throw new Error(data.message || 'failed');
            } else {
                console.log('moneySent:', data);
                window.scrollTo(0, 0)
                handleSendBarFromBeneficiary()
                setOpenSendBar(true)
                fetchAccountsAndWalletData()
            }

        } catch (error) {
            console.error('Error while sending money:', error.message);
            setSendErrorBar({ state: true, message: 'Failed to send payment. Try again later' })
        } finally {
            setIsSubmitting(false);
        }
    }


    const customStyles = {
        indicatorSeparator: () => ({
            display: 'none',
        }),
        control: (base) => ({
            ...base,
            borderColor: '#F3F0F7',
            padding: '4px',
            borderRadius: '8px',
            boxShadow: '0 1px 2px 0 #1D1C1F0D',
            borderWidth: '1.2px'
        }),
        singleValue: (base) => ({
            ...base,
            color: '#78757A',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 999,
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? '#F3F0F7' : 'white',
            color: 'black',
            padding: 10,
            cursor: 'pointer',
        }),
    };

    // const [sourceAcct, setSourceAcct] = useState()
    // const [sourceAcctInCrypto, setSourceAcctInCrypto] = useState()
    // const [countries, setCountries] = useState(country[0])
    // const [crypto, setCrypto] = useState(CryptocurrencyType[0])
    // const [networkType, setNetworkType] = useState(NetworkType[0])

    // const handleSourceAcctChange = (Option) => {
    //     setSourceAcct(Option)
    // }
    // const handleSourceAcctChangeInCrypto = (Option) => {
    //     setSourceAcctInCrypto(Option)
    // }
    const handleBeneficiaryAcctChange = (Option) => {
        setBeneficiaryAcct(Option);
        setFormDatas(prev => ({
            ...prev,
            beneficiary: Option.value.replace('bank-', '')
        }));
        setErrors(prev => ({
            ...prev,
            beneficiaryAcct: ''
        }));
    };

    const handleBeneficiaryAcctChangeInCrypto = (Option) => {
        setBeneficiaryAcctInCrypto(Option);
        setCryptoFormData(prev => ({
            ...prev,
            beneficiary: Option.value.replace('crypto-', '')
        }));
        setErrors(prev => ({
            ...prev,
            beneficiaryAcctInCrypto: ''
        }));
    };

    useEffect(() => {
        if (beneficiaryAcct?.currency) {
            const matchedCountry = countryOptionsWithRates.find(
                (country) => country.currency === beneficiaryAcct.currency
            );
            if (matchedCountry) {
                setSelectedBenAcct({ ...matchedCountry })
                setFormDatas((prev) => ({
                    ...prev,
                    currency: matchedCountry.currency
                }))
            }
        }
    }, [beneficiaryAcct, setFormDatas, countryOptionsWithRates]);

    useEffect(() => {
        let timeout;
        if (!sendBarFromBeneficiary) {
            timeout = setTimeout(() => {
                setBeneficiaryAcct(null)
                setBeneficiaryAcctInCrypto(null)
                setFormDatas(prev => ({ ...prev, amount: '' }))
                setCryptoFormData(prev => ({ ...prev, amount: '' }))
                setErrors({})
            }, 5200);
        }

        return () => clearTimeout(timeout);
    }, [sendBarFromBeneficiary, setFormDatas, setCryptoFormData, setBeneficiaryAcct, setBeneficiaryAcctInCrypto]);

    // const handleFileChange = async (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         setFormDatas((prev) => ({
    //             ...prev,
    //             file: file,
    //         }));
    //         setFile(file)
    //     }
    // };

    // const handleCountries = (Option) => {
    //     setCountries(Option)
    // }
    // const handleCrypto = (Option) => {
    //     setCrypto(Option)
    // }
    // const handleNetworkType = (Option) => {
    //     setNetworkType(Option)
    // }

    return (
        <div className={`fixed top-0 h-screen bg-white lg:p-10 py-8 px-4 duration-700 text-black z-50 overflow-auto ${sendBarFromBeneficiary ? 'sm:w-[510px] w-full right-0' : 'right-[-100%] w-[40%]'}`}>
            <div className='flex justify-between gap-5'>
                <div>
                    <h1 className='text-[20px] font-medium'>Send Money</h1>
                    <p className='text-[14px] font-normal text-[#525154]'>Easily send funds to anyone, anywhere, in just a few steps.</p>
                </div>
                <img
                    className='size-5 mt-1 cursor-pointer' src={close} alt=""
                    onClick={handleSendBarFromBeneficiary}
                />
            </div>
            <div className='mt-7 flex gap-4 border-b-black/30 border-b'>
                <p
                    onClick={() => {
                        setMethod('bank')
                        setBeneficiaryAcct(null)
                        setBeneficiaryAcctInCrypto(null)
                        setFormDatas(prev => ({ ...prev, amount: '' }))
                        setCryptoFormData(prev => ({ ...prev, amount: '' }))
                        setErrors({})
                        // setFile(null)
                    }}
                    className={method === 'bank' ? 'cursor-pointer text-[#491597] border-b-[#491597] border-b-2 pb-2 duration-700 transition-all' : 'cursor-pointer pb-2 duration-700 transition-all'}>Bank transfer</p>
                <p
                    onClick={() => {
                        setMethod('crypto')
                        setBeneficiaryAcct(null)
                        setBeneficiaryAcctInCrypto(null)
                        setFormDatas(prev => ({ ...prev, amount: '' }))
                        setCryptoFormData(prev => ({ ...prev, amount: '' }))
                        setErrors({})
                        // setFile(null)
                    }}
                    className={method === 'crypto' ? 'cursor-pointer text-[#491597] border-b-[#491597] border-b-2 pb-2 duration-700 transition-all' : 'cursor-pointer pb-2 duration-700 transition-all'}>Cryptocurrency</p>
            </div>
            {method === 'bank' ?
                (
                    <div className='mt-7 text-[14px] font-normal text-[#525154]'>
                        {/* <div>
                            <label className='text-black/50' htmlFor="code">Source Account</label>
                            <div className='mt-1'>
                                <Select
                                    styles={customStyles}
                                    options={currencyOptions}
                                    value={sourceAcct}
                                    onChange={handleSourceAcctChange}
                                    isSearchable={false}
                                    className='rounded-m w-full outline-none'
                                />
                            </div>
                        </div> */}

                        <div className='mt-5'>
                            <label className='text-black/50' htmlFor="fullName">Account</label>
                            <div className='mt-1'>
                                <Select
                                    styles={customStyles}
                                    options={BankBeneficairyOptions}
                                    value={beneficiaryAcct}
                                    onChange={handleBeneficiaryAcctChange}
                                    isSearchable={false}
                                    className='rounded-m w-full outline-none'
                                />
                                {errors.beneficiaryAcct && (
                                    <p className="text-red-500 text-sm mt-1">{errors.beneficiaryAcct}</p>
                                )}
                            </div>
                        </div>
                        <div className='mt-5'>
                            <label htmlFor="amount">Amount</label>
                            <div className='flex items-center gap-2'>
                                <div className='flex items-center w-full relative'>
                                    <input
                                        className='border-[1.2px] border-[#D2D0D6] shadow-custom-light py-[10px] pl-8 w-full outline-none rounded-md'
                                        placeholder='0'
                                        type="number"
                                        name="amount"
                                        value={formDatas.amount}
                                        onChange={(e) =>
                                            setFormDatas(prev => ({ ...prev, amount: e.target.value }),
                                                setErrors(prev => ({
                                                    ...prev,
                                                    amount: ''
                                                }))
                                            )}
                                        id=""
                                        min="0"
                                        onKeyDown={(e) => {
                                            // Prevent e, +, -, ., and other non-numeric keys
                                            const invalidChars = ['e', 'E', '+', '-', '.'];
                                            if (invalidChars.includes(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}

                                    />
                                    <p className='absolute ml-3 text-[20px] text-[#525154]'>$</p>
                                </div>
                                {/* <button className='py-[10px] px-4 bg-[#F9F7FC] text-[#E8E1F5] rounded-md'>Max</button> */}
                            </div>
                            {selectedBenAcct && formDatas.amount && (
                                <p className="mt-2 text-sm text-gray-700">
                                    = {selectedBenAcct.symbol}
                                    {(parseFloat(formDatas.amount) * selectedBenAcct.rate).toLocaleString()}{" "}
                                    {selectedBenAcct.currency}
                                </p>
                            )}
                            {errors.amount && (
                                <p className="text-red-500 text-sm mt-1">{errors.amount}</p>
                            )}
                        </div>
                        {/* <div className='w-full mt-5'>
                            <label className='text-black/50' htmlFor="file">
                                <p>Upload Invoice</p>
                                <div className='bg-[#efedf3] cursor-pointer rounded-md h-[200px] border-[1.5px] border-black/30 flex items-center justify-center'>
                                    {file ? (
                                        <img
                                            src={URL.createObjectURL(file)}
                                            alt=''
                                            className='w-full h-[200px] rounded-md cursor-pointer object-cover'
                                        />
                                    ) : (
                                        <FaRegImage className='text-[25px] text-black/40' />
                                    )}
                                </div>
                                <input
                                    type="file"
                                    accept=".pdf,.png,.jpg,.jpeg"
                                    id="file"
                                    onChange={handleFileChange}
                                    hidden
                                />
                            </label>
                            <p className='text-black/50'>(Optional but required for ghanian transfer)</p>
                        </div> */}

                        <div className='mt-5'>
                            <label className='text-black/50' htmlFor="amount">Remark</label>
                            <div className='flex items-center gap-2'>
                                <input
                                    className='border-[1.2px] border-[#D2D0D6] shadow-custom-light py-[10px] pl-2 w-full outline-none rounded-md'
                                    placeholder='What’s this for?'
                                    type="text"
                                    name="note"
                                    value={formDatas.note}
                                    onChange={(e) =>
                                        setFormDatas(prev => ({ ...prev, note: e.target.value }),
                                            setErrors(prev => ({
                                                ...prev,
                                                note: ''
                                            }))
                                        )}
                                    id=""
                                />
                            </div>
                            {errors.note && (
                                <p className="text-red-500 text-sm mt-1">{errors.note}</p>
                            )}
                        </div>

                        {/* <div className='mt-7'>
                            <div className='flex gap-3 items-center text-black/70'>
                                {toggle ? (
                                    <img
                                        className='cursor-pointer'
                                        src={OnToggle}
                                        alt=""
                                        onClick={() => setToggle(false)}
                                    />

                                ) : (
                                    <img
                                        className='cursor-pointer'
                                        src={OffToggle}
                                        alt=""
                                        onClick={() => setToggle(true)}
                                    />
                                )}
                                <p className='text-[16px] font-medium text-[#525154]'>Convert to client's currency</p>
                            </div>
                        </div> */}
                        <div className='flex gap-2 mt-12'>
                            <button
                                className='p-3 rounded-lg w-[25%] border-[1.2px] border-black/10'
                                onClick={handleSendBarFromBeneficiary}
                            >
                                Cancel
                            </button>
                            <button
                                className={`p-3 rounded-lg text-white w-[80%] ${isSubmitting ? 'bg-[#E8E1F5]' : 'bg-[#531CB3]'}`}
                                onClick={(e) => {
                                    sendMoney(e)
                                }}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    'Loading...'
                                ) : (
                                    'Send Money'
                                )}
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className='mt-7 text-[14px] font-normal text-[#525154]'>
                        {/* <div>
                            <label className='text-black/50' htmlFor="code">Source Account</label>
                            <div className='mt-1'>
                                <Select
                                    styles={customStyles}
                                    options={currencyOptionsInCrypto}
                                    value={sourceAcctInCrypto}
                                    onChange={handleSourceAcctChangeInCrypto}
                                    isSearchable={false}
                                    className='rounded-m w-full outline-none'
                                />
                            </div>
                        </div> */}

                        <div className='mt-5'>
                            <label className='text-black/50' htmlFor="fullName">Account</label>
                            <div className='mt-1'>
                                <Select
                                    styles={customStyles}
                                    options={BeneficairyOptionsInCrypto}
                                    value={beneficiaryAcctInCrypto}
                                    onChange={handleBeneficiaryAcctChangeInCrypto}
                                    isSearchable={false}
                                    className='rounded-m w-full outline-none'
                                />
                                {errors.beneficiaryAcctInCrypto && (
                                    <p className="text-red-500 text-sm mt-1">{errors.beneficiaryAcctInCrypto}</p>
                                )}
                            </div>
                        </div>
                        <div className='mt-5'>
                            <label className='text-black/50' htmlFor="amount">Amount</label>
                            <div className='flex items-center w-full relative'>
                                <input
                                    className='border-[1.2px] border-[#D2D0D6] shadow-custom-light py-[10px] pl-8 w-full outline-none rounded-md'
                                    placeholder='0'
                                    type="number"
                                    name="amount"
                                    value={cryptoformData.amount}
                                    onChange={(e) =>
                                        setCryptoFormData(prev => ({ ...prev, amount: e.target.value }),
                                            setErrors(prev => ({
                                                ...prev,
                                                amount: ''
                                            }))
                                        )}
                                    id=""
                                    min="0"
                                    onKeyDown={(e) => {
                                        // Prevent e, +, -, ., and other non-numeric keys
                                        const invalidChars = ['e', 'E', '+', '-', '.'];
                                        if (invalidChars.includes(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}

                                />
                                {/* <AiTwotoneQuestionCircle className='ml-[-30px]' /> */}
                                <p className='absolute ml-3 text-[20px] text-[#525154]'>$</p>
                            </div>
                            {errors.amount && (
                                <p className="text-red-500 text-sm mt-1">{errors.amount}</p>
                            )}
                        </div>
                        <div className='flex gap-2 mt-12'>
                            <button
                                className='p-3 rounded-lg w-[25%] border-[1.2px] border-black/10'
                                onClick={handleSendBarFromBeneficiary}
                            >
                                Cancel
                            </button>
                            <button
                                className={`p-3 rounded-lg text-white w-[80%] ${isSubmitting ? 'bg-[#E8E1F5]' : 'bg-[#531CB3]'}`}
                                onClick={(e) => {
                                    sendMoneyInCrypto(e)
                                }}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    'Loading...'
                                ) : (
                                    'Send Money'
                                )}
                            </button>
                        </div>
                    </div>
                )}
            {/* <SendModal formData={formData} beneficiaryAcct={beneficiaryAcct} SendErrorBar={SendErrorBar} openSendBar={openSendBar} setOpenSendBar={setOpenSendBar} setSendErrorBar={setSendErrorBar} /> */}
        </div>
    )
}
export default SendBarFromBeneficiary